/**
 * The value to assign to `data-testid` for testing purposes. This value should not be relied
 * upon in production (it will be elided in many cases).
 *
 * From `dom-testing-library` docs:
 *
 * > It also exposes a recommended way to find elements by a data-testid as an "escape hatch"
 * > for elements where the text content and label do not make sense or is not practical.
 *
 * @see https://testing-library.com/docs/intro
 */

/**
 * Props for a component that accepts testId.
 */

/**
 * Appends a postfix to a testId if it is defined. Empty string is not considered defined.
 *
 * @param testId the string to append a postfix too
 * @param postfix string to append to the testId if it's defined
 */
export function postfixTestId(testId, postfix) {
  // TODO: in production, change this function to always return undefined
  if (testId) {
    return `${testId}-${postfix}`;
  } else {
    return testId;
  }
}
//# sourceMappingURL=index.js.map